"use client";

import * as React from "react";
import * as SeparatorPrimitive from "@radix-ui/react-separator";

import { DIVIDER_SURFACE_STYLE } from "@/lib/surface-styles";
import { cn } from "@/lib/utils";

/**
 * Horizontal/vertical divider. Uses `DIVIDER_SURFACE_STYLE` — do not override fill.
 *
 * - In flow: `<Separator />` or `<Separator className="mt-3" />` (block width).
 * - Header/footer chrome: `className="absolute bottom-0 inset-x-0"` on a `relative`
 *   row (content may use `px-*`; the rule is full-bleed across the panel).
 *   Never pair absolute positioning with `w-full` — width comes from inset anchors.
 * - Flex row: `className="flex-1"` (e.g. date separators).
 */
function Separator({
  className,
  orientation = "horizontal",
  decorative = true,
  ref,
  ...props
}: React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root> & {
  ref?: React.Ref<React.ElementRef<typeof SeparatorPrimitive.Root>>;
}) {
  return (
    <SeparatorPrimitive.Root
      ref={ref}
      decorative={decorative}
      orientation={orientation}
      className={cn(
        "shrink-0",
        orientation === "horizontal" ? "h-[1px]" : "h-full w-[1px]",
        className,
      )}
      style={DIVIDER_SURFACE_STYLE}
      {...props}
    />
  );
}

export { Separator };
